:global body.disableBlur {
  :local {
    .contextMenu {
      background-color: rgb(40, 40, 40);
      backdrop-filter: none;
    }
  }
}
.contextMenu {
  position: fixed;
  z-index: 11111;
  z-index: 11111111111111;
  overflow: hidden;
  flex-shrink: 0;
  border: solid 1px rgba(255, 255, 255, 0.2);
  border-radius: 12px;

  background-color: rgba(40, 40, 40, 0.86);
  backdrop-filter: blur(34px);

  &.mobile {
    right: 0;
    bottom: 0;
    left: 0;
    border: none;
    border-right: none;
    border-bottom: none;
    border-left: none;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    background-color: var(--pane-color);
  }
}

.darkBackground {
  position: absolute;
  z-index: 11111111111111111111111111111;
  background-color: rgba(0, 0, 0, 0.8);
  inset: 0;
}

.contextMenuInner {
  display: flex;
  flex-direction: column;
  padding: 4px;
  animation: showUp;
  animation-duration: 0.2s;
  gap: 3px;
  animation-fill-mode: forwards;
}

@keyframes showUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobile .item {
  padding: 10px;
}

.item {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  font-size: 14px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &.alert {
    color: var(--alert-color);
  }
  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    &:hover {
      background-color: transparent;
    }
  }
  .label {
    margin-left: 5px;
  }
  .arrow {
    padding-left: 6px;
    margin-left: auto;
  }
}

.separator {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
}
.title {
  margin-top: 4px;
  margin-left: 6px;
  user-select: none;
  font-size: 14px;
}
